import { isAxiosError } from 'axios'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { ConfirmationDialog } from '@dhl/confirmation-dialog'
import { useDeleteAdminActionsActionid } from '@dhl/receiver-dhl-extra-api'

import { Body1 } from '@dhl-ui/components'
import { links } from '~/AppRoutes'
import { useNotificationMessage } from '~/common'

type Props = {
  open: boolean
  id: string
  onClose: () => void
}

export const PromotionDangerZoneDialog = ({ open, id, onClose }: Props) => {
  const navigate = useNavigate()
  const { showError, showSuccess } = useNotificationMessage()
  const { t } = useTranslation()
  const { mutateAsync: deletePromotion } = useDeleteAdminActionsActionid()

  const handleDelete = async () => {
    try {
      await deletePromotion({
        actionId: id,
      })

      navigate(links.promotionsOverviewLink())
      showSuccess(t('admin.dhlExtraPage.promotionsPage.promotionDeleteSuccess'))
    } catch (error) {
      if (isAxiosError(error)) {
        showError(error.message)
      }
    }
  }

  return (
    <ConfirmationDialog
      open={open}
      titleText={t(`admin.dhlExtraPage.promotionsPage.dangerZoneDialog.header`)}
      acceptText={t(`admin.dhlExtraPage.promotionsPage.dangerZoneDialog.deleteButton`)}
      rejectText={t(`admin.dhlExtraPage.promotionsPage.dangerZoneDialog.cancelButton`)}
      onAccept={handleDelete}
      onReject={onClose}
      data-testid="confirmationDangerDialog"
    >
      <Body1>{t(`admin.dhlExtraPage.promotionsPage.dangerZoneDialog.message`)}</Body1>
    </ConfirmationDialog>
  )
}
